import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router";
import queryString from "query-string";
import {
  Container,
  Button,
  Modal,
  Row,
  Col,
  Image,
  Table,
  CloseButton,
  Form,
  InputGroup,
  ToggleButton,
  ButtonGroup,
} from "@themesberg/react-bootstrap";
import { authFetch, useAuth } from "../../auth";
import { FormattedMessage } from "react-intl";
import { Routes } from "../../routes";
import { MatNotAllowed } from "../../components/Modal";

import SigninLogo from "../../assets/img/signin_logo_new.png";
import TestImg from "../../assets/upload/1027601109527.png";

const RegAttSuccess = ({ duplicate, onHideClick }) => {
  return (
    <Modal as={Modal.Dialog} centered show={true}>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage
            id={duplicate ? "attentionCompDup" : "attentionComp"}
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <FormattedMessage
            id={duplicate ? "attentionAddedDup" : "attentionAdded"}
          />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHideClick}>
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const RegMatSuccess = ({ onHideClick, id, disabled }) => {
  return (
    <Modal as={Modal.Dialog} centered show={true}>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <FormattedMessage id={id} />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={disabled} onClick={onHideClick}>
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const ReqMatchingReason = ({ id,Name,RegistrationID, onCancel }) => {
  const [control, setControl] = useState({
    show: false,
    matShow: false,
    matDenial: false,
    matId: "",
    disabled: false,
  });
  const { show, matId,matShow,matDenial,disabled } = control;

  const [msg, setMsg] = useState({
    reasonMsg: "",
  });

  const {
    reasonMsg,
  } = msg;

  const [input, setInput] = useState({
    MatchingReason: "",
    MatchingCivility: 0,
    MatchingCompanyName: "",
    MatchingEmail: "",
    MatchingName: "",
    MatchingCountry: 0,
    MatchingPhone: "",
  });

  const {
    MatchingReason,
    MatchingCivility,
    MatchingCompanyName,
    MatchingEmail,
    MatchingName,
    MatchingCountry,
    MatchingPhone,
  } = input;

  const onReasonChange = (e) => {
    let { name, value } = e.target;
    
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const onCivilityChange = (e) => {
    const { name, value } = e.target;

    if (name === "civility" && value === "1") {
      setInput((prev) => ({ ...prev, MatchingCivility: 1 }));
    }
    else if (name === "civility" && value === "2") {
      setInput((prev) => ({ ...prev, MatchingCivility: 2 }));
    }
    else if (name === "country" && value === "1") {
      setInput((prev) => ({ ...prev, MatchingCountry: 1 }));
    }
    else if (name === "country" && value === "2") {
      setInput((prev) => ({ ...prev, MatchingCountry: 2 }));
    }
  };
  
  const onQuickHandle = (e) => {
    e.preventDefault();

    setInput((prev) => ({ ...prev, MatchingReason: "Applied for matching company!" }));
  };

  const onMatchingHandle = (e) => {
    e.preventDefault();

    console.log(Name);
    console.log(RegistrationID);

    authFetch(process.env.REACT_APP_API_URL + "/api/matchingCom", {
      method: "post",
      body: JSON.stringify({
        target_id: id,
        company_nm: Name,
        registrationID: RegistrationID,
        reason: MatchingReason,
        civility: MatchingCivility,
        country: MatchingCountry,
        name: MatchingName,
        email: MatchingEmail,
        phone: MatchingPhone
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        setControl((prev) => ({
          ...prev,
          matId: "matchingAdded",
          disabled: false,
        }));
      } else if (resp.status === 201) {
        setControl((prev) => ({
          ...prev,
          matShow: true,
          matId: "matchingAddedDup",
          disabled: false,
        }));
      } else if (resp.status === 401) {
        setControl((prev) => ({ ...prev, matDenial: true ,
          disabled: false,}));
      } else {
        console.log(resp);
        setControl((prev) => ({
          ...prev,
          matShow: true,
          matId: "matchingError",
          disabled: false,
        }));
      }
    });
  };

  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="matchingReqTitle" />
        </Modal.Title>
        <CloseButton onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group id="matchingCivility" className="mb-4">
            <Form.Label>
              호칭
            </Form.Label>
            <InputGroup>
              <InputGroup.Radio
                name="civility"
                value="1"
                onChange={onCivilityChange}
              />
              Mr.
              <InputGroup.Radio
                name="civility"
                value="2"
                onChange={onCivilityChange}
              />
              Mrs.
            </InputGroup>
          </Form.Group>
          <Form.Group id="matchingCompanyName" className="mb-4">
            <Form.Label>
              회사 명
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="text"
                placeholder="Example"
                name="MatchingCompanyName"
                value={MatchingCompanyName}
                onChange={onReasonChange}
              />
            </InputGroup>
          </Form.Group>
          <Form.Group id="matchingEmail" className="mb-4">
            <Form.Label>
              요청자 이메일
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="text"
                placeholder="Example"
                name="MatchingEmail"
                value={MatchingEmail}
                onChange={onReasonChange}
              />
            </InputGroup>
          </Form.Group>
          <Form.Group id="matchingName" className="mb-4">
            <Form.Label>
              요청자 이름
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="text"
                placeholder="Example"
                name="MatchingName"
                value={MatchingName}
                onChange={onReasonChange}
              />
            </InputGroup>
          </Form.Group>
          <Form.Group id="matchingCountry" className="mb-4">
            <Form.Label>
              요청회사 국가
            </Form.Label>
            <InputGroup>
              <InputGroup.Radio
                name="country"
                value="1"
                onChange={onCivilityChange}
              />
              대한민국
              <InputGroup.Radio
                name="country"
                value="2"
                onChange={onCivilityChange}
              />
              러시아
            </InputGroup>
          </Form.Group>
          <Form.Group id="matchingPhone" className="mb-4">
            <Form.Label>
              요청자 전화번호
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="text"
                placeholder="Example"
                name="MatchingPhone"
                value={MatchingPhone}
                onChange={onReasonChange}
              />
            </InputGroup>
          </Form.Group>
          <Form.Group id="matchingReason" className="mb-4">
            <Form.Label>
              매칭 요청한 이유(메일 내용으로 전송합니다.)
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="text"
                placeholder="Example"
                name="MatchingReason"
                className="w-70"
                value={MatchingReason}
                onChange={onReasonChange}
              />
              <Button
                variant="primary"
                type="submit"
                className="w-30"
                onClick={onQuickHandle}
              >
                Quick Message
              </Button>
            </InputGroup>
            {reasonMsg && <div className="text-danger">{reasonMsg}</div>}
          </Form.Group>
          <div className="mt-4">
            <Button
              variant="primary"
              type="submit"
              className="w-100"
              onClick={onMatchingHandle}
            >
              <FormattedMessage id="matchingReq" />
            </Button>
            {matShow && (
              <RegMatSuccess
                id={matId}
                disabled={disabled}
                onHideClick={() => {
                  setControl((prev) => ({ ...prev, matShow: false }));
                }}
              />
            )}
            {matDenial && (
              <MatNotAllowed
                onCancel={() => {
                  setControl((prev) => ({ ...prev, matDenial: false }));
                }}
                id="matNotAllowed"
              />
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
    
  );
};

/*
const CompanyItem = () => {
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>
            <FormattedMessage id="itemNm" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>item1</td>
        </tr>
        <tr>
          <td>3</td>
          <td>item3</td>
        </tr>
        <tr>
          <td>4</td>
          <td>item4</td>
        </tr>
        <tr>
          <td>5</td>
          <td>item5</td>
        </tr>
      </tbody>
    </Table>
  );
};
*/

export default () => {
  const [info, setInfo] = useState(null);
  const [control, setControl] = useState({
    attDup: false,
    attShow: false,
    matShow: false,
    matDenial: false,
    resShow: false,
    matId: "",
    disabled: false,
  });
  const { attDup, attShow, matShow, matDenial,resShow, matId, disabled } = control;

  var text_Worker = "0";
  var text_Revenue = "0";

  const location = useLocation();
  const history = useHistory();
  const [logged] = useAuth();

  const query = queryString.parse(location.search);


  useEffect(() => {
    authFetch(
      process.env.REACT_APP_API_URL +
        `/api/company?index=${query.index}&id=${query.id}`
    )
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp) {
          console.log(resp);
          resp.Worker = resp.Worker.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          resp.Revenue = resp.Revenue.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          if(resp.Website.includes("http") == false) {
            resp.Website = "http://" + resp.Website
          }
            

          resp.image_path = "upload/" + resp.RegistrationID.toString() + ".png"
          setInfo(resp);
          console.log(text_Revenue);
          console.log(resp);
        } else {
          history.push("/404");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [history, logged, query.id, query.index]);

  const onAttentionReg = () => {
    authFetch(process.env.REACT_APP_API_URL + "/api/reg-attention", {
      method: "post",
      body: JSON.stringify({
        target_id: query.id,
        company_nm: info.Name,
        reg_id: info.RegistrationID,
      }),
    }).then((resp) => {
      console.log(resp.status);
      if (resp.status === 200) {
        setControl((prev) => ({ ...prev, attShow: true, attDup: false }));
      } else if (resp.status === 201) {
        setControl((prev) => ({ ...prev, attShow: true, attDup: true }));
      } else {
        console.log(resp);
      }
    });
  };

  const onMatchingReq = () => {
    setControl({
      resShow: true,
      matId: "matProccess",
      matControl: true,
      disabled: true,
    });

    /*
    authFetch(process.env.REACT_APP_API_URL + "/api/matchingCom", {
      method: "post",
      body: JSON.stringify({
        registrationID: info.RegistrationID,
        emailList: info.EmailAddress,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        setControl((prev) => ({
          ...prev,
          matId: "matchingAdded",
          disabled: false,
        }));
      } else if (resp.status === 201) {
        setControl((prev) => ({
          ...prev,
          matShow: true,
          matId: "matchingAddedDup",
          disabled: false,
        }));
      } else if (resp.status === 401) {
        setControl((prev) => ({ ...prev, matDenial: true ,
          disabled: false,}));
      } else {
        console.log(resp);
        setControl((prev) => ({
          ...prev,
          matShow: true,
          matId: "matchingError",
          disabled: false,
        }));
      }
    });
    */
  };

  console.log(info);

  var val_country = ""

  if(info != null && info.logo == null)
    info.logo = "profile-cover.jpg"

  if(info != null && info.Country == 1)
    val_country = "Korea"
  else if(info != null && info.Country == 2)
    val_country = "Russia"

  return (
    <div className="bg-white mx-4" style={{ width: "90%" }}>
      {info && (
        <div className="p-4">
          {info.UserInfo !== info.RegistrationID && (
            <Row>
              <Col className="text-right">
                <Button onClick={onAttentionReg} className="mx-2">
                  <FormattedMessage id="attentionReg" />
                </Button>
                <Button onClick={onMatchingReq}>
                  <FormattedMessage id="matchingReq" />
                </Button>
              </Col>
            </Row>
          )}
          <Image variant="top" src={info.logo} />
          <Row>
            <h1 className="text-center pt-4">{info.Name}</h1>
            <h3 className="text-center">
              #{info.keyword}
            </h3>
          </Row>
          <Row>
            <Col>
              <Table hover>
                <tbody>
                  <tr>
                    <th>
                      <FormattedMessage id="country" />
                    </th>
                    <td>
                      {
                        val_country
                        // info.country? info.country == 1 ? "Russia" : "Korea" : ""
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="registration" />
                    </th>
                    <td>{info.RegistrationID}</td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="address" />
                    </th>
                    <td style={{ whiteSpace: "normal" }}>
                      {info.LegalAddress}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="principal" />
                    </th>
                    <td>{info.PrincipalName}</td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="business" />
                    </th>
                    <td>{info.LineOfBusiness}</td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="phone" />
                    </th>
                    <td>{info.Phone ? info.Phone.join("").replaceAll("\r\n", " / ") : ""}</td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="email" />
                    </th>
                    <td>
                      {info.EmailAddress ? info.EmailAddress.join("").replaceAll("\r\n", " / ") : ""}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="establish" />
                    </th>
                    <td>
                      {
                        //info.RegistrationDate
                        info.RegistrationAt
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="website" />
                    </th>
                    <td><a href={info.Website} target="_blank" rel="noopener noreferrer">{info.Website}</a></td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="worker" />
                    </th>
                    <td>{info.Worker}</td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="revenue" /> (RUB)
                    </th>
                    <td>{info.Revenue}</td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="company_content" />
                    </th>
                    <td>{info.Content}</td>
                  </tr>
                  <tr>
                    <th>
                      회사 관련 자료
                    </th>
                    <td><a href={info.image_path} download="image.png"> Download Here </a></td>
                  </tr>
                  <tr>
                    <th>
                      <FormattedMessage id="suppliers" />
                    </th>
                    <td>{info.supplier}</td>
                  </tr>
                  <tr>
                    <th>
                      IPC
                    </th>
                    <td>{info.IPC}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      )}
      {attShow && (
        <RegAttSuccess
          duplicate={attDup}
          onHideClick={() => {
            setControl((prev) => ({ ...prev, attShow: false }));
          }}
        />
      )}
      {matShow && (
        <RegMatSuccess
          id={matId}
          disabled={disabled}
          onHideClick={() => {
            setControl((prev) => ({ ...prev, matShow: false }));
          }}
        />
      )}
      {matDenial && (
        <MatNotAllowed
          onCancel={() => {
            setControl((prev) => ({ ...prev, matDenial: false }));
          }}
          id="matNotAllowed"
        />
      )}
      {resShow && (
        <ReqMatchingReason
          id={query.id}
          Name={info.Name}
          RegistrationID={info.RegistrationID}
          onCancel={() => {
            setControl((prev) => ({ ...prev, resShow: false }));
          }}
        />
      )}
    </div>
  );
};
